import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import rivertonImg from "../assets/images/riverton.webp";
import HeroSection from "../components/HeroSection";
import subsHero from "../assets/images/subsidiaries-hero.jpg";
import cleaningImg from "../assets/images/cleaning.jpg";
import securityImg from "../assets/images/security.jpg";
import ictImg from "../assets/images/ict.jpg";
import hrImg from "../assets/images/hr.jpg";
import exploitsImg from "../assets/images/exploits.jpg";
import debtImg from "../assets/images/debt.jpg";

// Brand logos
import aspenLogo from "../assets/images/logos/aspen-logo-removebg-preview.png";
import exploitsLogo from "../assets/images/logos/expl_university-removebg-preview.png";
import geminiLogo from "../assets/images/logos/Gemini_Generated_Image_thz4hmthz4hmthz4-removebg-preview.png";

export default function SubsidiariesPage() {
  const subsidiariesDetailed = [
    {
      name: "Aspen Cleaning",
      category: "Cleaning Services",
      description:
        "Aspen Cleaning provides professional cleaning services for both residential and commercial properties. Our trained team uses eco-friendly products and modern equipment to deliver exceptional results.",
      services: [
        "Commercial Cleaning",
        "Residential Cleaning",
      ],
      image: cleaningImg,
      url: "http://aspenmw.com",
    },
    {
      name: "Aspen Security",
      category: "Security Services",
      description:
        "Aspen Security delivers comprehensive security solutions with highly trained security personnel and advanced surveillance systems to protect your assets and people.",
      services: [
        "Manned Guarding",
        "Mobile Patrols",
      ],
      image: securityImg,
      url: "http://aspenmw.com",
    },
    {
      name: "Aspen ICT",
      category: "Technology Solutions",
      description:
        "Aspen ICT offers cutting-edge technology solutions including software development, IT infrastructure, and fleet management systems tailored to your business needs.",
      services: [
        "Software Development",
        "IT Consulting",
        "Fleet Tracking",
      ],
      image: ictImg,
      url: "http://aspenmw.com",
    },
    {
      name: "Madison Recruitment",
      category: "Human Resources",
      description:
        "Madison Recruitment specializes in talent acquisition and HR management, connecting top talent with leading organizations across various industries.",
      services: [
        "Recruitment Services",
        "HR Consulting",
        "Payroll Management",
      ],
      image: hrImg,
      url: "https://jobs.madisonmw.com/",
    },
    {
      name: "Exploits University",
      category: "Higher Education",
      description:
        "Exploits University is an accredited private institution offering quality higher education programs designed to prepare students for successful careers.",
      services: [
        "Undergraduate Programs",
        "Postgraduate Programs",
        "Professional Courses",
      ],
      image: exploitsImg,
      url: "https://exploitsmw.com/",
    },
    {
      name: "Riverton Dairy",
      category: "Food & Beverage",
      description:
        "Experience the richness of our high-quality dairy products such as yogurts, cheese and many more!",
      services: [
        "Dairy Production",
        "Yogurts",
      ],
      image: rivertonImg,
      url: "http://rivertonmw.com",
    },
    {
      name: "Debt Collection Services",
      category: "Financial Services",
      description:
        "Professional debt recovery solutions to improve your business cash flow and financial planning.",
      services: [
        "Debt Recovery",
        "Outsourced Collections",
        "Financial Planning Support",
      ],
      image: debtImg,
      url: "https://jobs.madisonmw.com/",
    },
  ];

  return (
    <>
      <HeroSection
        title="OUR SUBSIDIARIES"
        description="Specialized companies delivering excellence across multiple sectors"
        imageUrl={subsHero}
        overlay="accent"
      />

      {/* Logos strip */}
      <section className="subsidiary-logos-section">
        <div className="subsidiary-logos">
              {[aspenLogo, exploitsLogo, geminiLogo].map((logo, i) => (
                <div className="subsidiary-logo" key={i}>
                  {i === 0 ? (
                    <a href="http://aspenmw.com" target="_blank" rel="noopener noreferrer">
                      <img src={logo} alt="Aspen logo" />
                    </a>
                  ) : i === 1 ? (
                    <a href="https://exploitsmw.com/" target="_blank" rel="noopener noreferrer">
                      <img src={logo} alt="Exploits University logo" />
                    </a>
                  ) : (
                    <a href="http://rivertonmw.com" target="_blank" rel="noopener noreferrer">
                      <img src={logo} alt="Riverton Dairy logo" />
                    </a>
                  )}
                </div>
              ))}
        </div>
      </section>

      <section className="subsidiaries-detail-section">
        {subsidiariesDetailed.map((sub, index) => (
          <SubsidiaryDetail key={index} {...sub} index={index} />
        ))}
      </section>
    </>
  );
}

function SubsidiaryDetail({
  name,
  category,
  description,
  services,
  image,
  url = "#",
  index,
}) {
  return (
    <motion.div
      className={`subsidiary-detail ${index % 2 === 0 ? "reverse" : ""}`}
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <div className="subsidiary-detail-image">
        <img src={image} alt={name} />
      </div>
      <div className="subsidiary-detail-content">
        <div className="subsidiary-category">{category}</div>
        <h2>{name}</h2>
        <p>{description}</p>
        <div className="services-list">
          <h4>Services Offered:</h4>
          <ul>
            {services.map((service, idx) => (
              <li key={idx}>{service}</li>
            ))}
          </ul>
        </div>
        <div style={{ marginTop: 20 }}>
          {url &&
            (url.startsWith("http") ? (
              <a
                className="subsidiary-link"
                href={url}
                target="_blank"
                rel="noreferrer"
              >
                Learn More <ArrowRight size={14} />
              </a>
            ) : (
              <a className="subsidiary-link" href={url}>
                Learn More <ArrowRight size={14} />
              </a>
            ))}
        </div>
      </div>
    </motion.div>
  );
}
